import React from 'react';
import Header from '@components/Header';
import { DoubleCheckIcon, LoaderIcon } from '@repo/icons';
import ActivityFilterSetter, { titleForActivityFilterType } from './Filter';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectActiveActivityFilter,
  selectActivity,
  selectActivityItemCount,
} from '@repo/redux/reducers/data/activity';
import { dismissAllActivityItems } from '@repo/redux/actions/activity';
import styles from './ActivityHeader.module.scss';
import DelayedLoader from '@components/DelayedLoader';
import { Overlay, Tooltip } from '@repo/components/tooltips';

export default function ActivityHeader() {
  const dispatch = useDispatch();
  const activity = useSelector(selectActivity);
  const activityItemCount = useSelector(selectActivityItemCount);
  const activityFilter = useSelector(selectActiveActivityFilter);

  const onDismissAll = () => {
    let title = `Dismiss All`;
    const count = activityItemCount.toLocaleString();
    const message = `Are you sure you want to dismiss all ${
      count === '0' ? '' : count + ' '
    }items?`;

    if (activityFilter) {
      title += ' ' + titleForActivityFilterType[activityFilter];
    } else {
      title += ' items';
    }

    window.app.confirm(
      {
        title,
        message,
        action: 'Dismiss All',
        variant: 'danger',
      },
      (confirmed) => {
        if (confirmed) {
          dispatch(dismissAllActivityItems({ alertOnSuccess: `Dismissed ${count} items` }));
        }
      },
    );
  };

  let dismissAllBtn = activity.items.size > 0 && (
    <Header.Action
      onClick={onDismissAll}
      className="btn-none"
      as="button"
      IconComponent={({ className }) => (
        <Tooltip overlay={<Overlay>Dismiss All</Overlay>} placement="bottom" delay>
          <DoubleCheckIcon className={className} hoverOpacity />
        </Tooltip>
      )}
      hover
    />
  );

  if (activity.isDeleting) {
    dismissAllBtn = <LoaderIcon width="16" height="16" />;
  }

  const actions = [dismissAllBtn, <ActivityFilterSetter disabled={activity.isDeleting} />];

  return (
    <Header
      actions={
        <>
          {actions
            .filter((x) => !!x)
            .map((x, i) => (
              <React.Fragment key={i}>{x}</React.Fragment>
            ))}
        </>
      }
      titleClassName={styles.title}
    >
      Home
      <DelayedLoader delay={150} loading={activity.isFetching} />
    </Header>
  );
}
